import React from "react"
import styles from "./TestDriveBookingFlow.module.sass"

interface CarSummaryProps {
  vinLpn?: string
  year: string
  brand: string
  model: string
  equipmentVariant: string
  body: string
  engine: string
  gear: string
  yourCar: string
}
const CarSummary = (props: CarSummaryProps): JSX.Element => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        <div className={`${styles.bookingDetails} car-summary`}>
          <h3>{props.yourCar}</h3>
          <ul>
            {props.vinLpn && (
              <li>
                <span>{props.vinLpn}</span>
              </li>
            )}
            <li>
              <span>{`${props.year} ${props.brand} ${props.model} ${props.equipmentVariant}`}</span>
            </li>
            <li>
              <span>{`${props.body} ${props.engine}, ${props.gear}`}</span>
            </li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CarSummary
